import { Sparkles } from 'lucide-react';

/**
 * AgentMark — the FieldIQ Agent's icon: an amber sparkle on a filled navy rounded square.
 *
 * One mark for both entry points (the sidebar footer card and the mobile header button),
 * so the two cannot drift. It is the fallback when the tenant has no agent avatar, or
 * the avatar fails to load.
 *
 * 22px IS THE OLD GLYPH'S BOX, AND THAT IS WHY. At 28px the sidebar card's subtitle needs
 * 112px and gets 109, so "Search or start a task" truncates; at 22px it fits as it did
 * before. Growing the mark is a layout change to the card, not a restyle of the icon.
 * It is block-level for the same reason: the glyph it replaced rendered as a block, and an
 * inline box sits on a text line that made the header button 2px taller than its siblings.
 *
 * THE COLOURS DO NOT FOLLOW THE THEME, ON PURPOSE. The fill is `--fi-brand` and the
 * sparkle is `--fi-signal-amber`; neither has a light twin, so the pair is the same
 * bytes in both themes, the same idea as the page header band. The amber is a FILL
 * colour here, drawn on a constant navy, never ink on a theme-following surface, which
 * is the combination that failed contrast in light mode. The inset amber edge is what
 * separates the square from a dark sidebar: the navy fill alone measures 1.19 against the
 * dark sidebar, so without the edge only a floating sparkle reads. At half strength the
 * edge clears 3:1 on that surface; lighter edges were measured and did not.
 */
export default function AgentMark({ size = 22 }: { size?: number }) {
  return (
    <span
      aria-hidden="true"
      data-testid="agent-mark"
      className="flex flex-shrink-0 items-center justify-center rounded-lg bg-fi-brand ring-1 ring-inset ring-fi-signal-amber/50"
      style={{ width: size, height: size }}
    >
      <Sparkles
        size={Math.round(size * 0.6)}
        strokeWidth={1.75}
        fill="currentColor"
        className="text-fi-signal-amber"
      />
    </span>
  );
}
